import { Standards } from "./Standards";

export { Standards };
